/**
 * @author: Khanh Le <quockhanhle1997@gmail.com>
 * @date: 27/07/2023
 */
export const OPEN_POLICY = 'OPEN_POLICY';
export const OPEN_POLICY_MUTATION = "OPEN_POLICY_MUTATION";

export default {
    namespace: 'policyModule',

    state:() => ({
        isOpenPolicy: false
    }),

    actions: {
        [OPEN_POLICY](context, payload) {
            context.commit(OPEN_POLICY_MUTATION, payload);
        }
    },
    mutations: {
        [OPEN_POLICY_MUTATION](state, payload = false) {
            state.isOpenPolicy = payload;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/policyModule.js